import { COLLATERAL_ONRAMP_CONTRACT_ADDRESS, USDC_E_CONTRACT_ADDRESS } from '@/constants/tokens'
import { OperationType, type SafeTransaction } from '@polymarket/builder-relayer-client'
import { encodeFunctionData } from 'viem'

const WRAP_ABI = [
	{
		name: 'wrap',
		type: 'function',
		stateMutability: 'nonpayable',
		inputs: [
			{ name: '_asset', type: 'address' },
			{ name: '_to', type: 'address' },
			{ name: '_amount', type: 'uint256' },
		],
		outputs: [],
	},
] as const

/**
 * Build a Safe transaction to wrap `amountWei` units of USDC.e into pUSD via
 * the Collateral Onramp. Caller must have already approved the Onramp to
 * spend USDC.e (handled by createAllApprovalTxs in approvals.ts).
 *
 * The wrapped pUSD is minted to the caller (`recipientAddress`).
 *
 * Source: https://docs.polymarket.com/concepts/pusd
 */
export function buildWrapTx(recipientAddress: string, amountWei: bigint): SafeTransaction {
	return {
		to: COLLATERAL_ONRAMP_CONTRACT_ADDRESS,
		value: '0',
		data: encodeFunctionData({
			abi: WRAP_ABI,
			functionName: 'wrap',
			args: [USDC_E_CONTRACT_ADDRESS, recipientAddress as `0x${string}`, amountWei],
		}),
		operation: OperationType.Call,
	}
}
